import { listPharmacies } from './index';

import { pharmaciesRouteStore } from '../domain/store';

export default (number) => {
  pharmaciesRouteStore.setValue('currentPage', number);
  return listPharmacies();
};
